<template>
  <v-card-text>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-form>
      <v-layout wrap justify-start pt-2>
        <v-flex xs12 sm12 md12 lg12 class="subheading">
          <span style="color:black">Title</span>
          <v-text-field class="pt-2 text-des" outlined v-model="title" dense hide-details>
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 pt-3 class="subheading">
          <span style="color:black">Description</span>
          <v-textarea outlined v-model="description" dense hide-details class="pt-2 text-des">
          </v-textarea>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 class="subheading pt-3">
          <span style="color:black">Video URL</span>
          <v-text-field class="pt-2 text-des" outlined v-model="link" dense hide-details>
          </v-text-field>
        </v-flex>
      </v-layout>
    </v-form>
    <v-card-actions class="py-4 justify-end headline lighten-2">
      <v-btn tile :color="appColor" light :ripple="false" depressed class="itemValue"
        @click="itemadd()"><span style="color:white;">Submit</span></v-btn>
    </v-card-actions>
  </v-card-text>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      title: "",
      description: "",
      link: "",
      appLoading: false,
      ServerError: false,
      appColor: "#427D2D",
    };
  },
  methods: {
    clearForm() {
      this.title = "";
      this.description = "";
      this.link = "";
    },
    itemadd() {
      if (!this.title) {
        this.$emit("show-msg", "Please Provide title.");
        return;
      }
      if (!this.description) {
        this.$emit("show-msg", "Please Provide description.");
        return;
      }
      if (!this.link) {
        this.$emit("show-msg", "Please Provide url.");
        return;
      }
      this.appLoading = true;
      axios({
        method: "POST",
        url:"/resource/addvideolink",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          title: this.title,
          description: this.description,
          link: this.link,
        },
      })
      .then((response) => {
        this.appLoading = false;
        if (response.data.status) {
          this.$emit("success", response.data.msg);
          this.clearForm();
        } else {
          this.$emit("show-msg", response.data.msg);
        }
      })
      .catch((err) => {
        this.appLoading = false;
        this.ServerError = true;
        console.log(err);
      });
    },
  },
};
</script>
